module.exports = __webpack_public_path__ + "static/media/tan-bench.e542a135.png";